import { defineComponent as O, useSlots as $, useAttrs as E, useCssModule as T, ref as u, watchEffect as D, watch as v, createBlock as j, openBlock as p, mergeProps as M, createSlots as R, withCtx as h, createElementBlock as y, createElementVNode as F, toDisplayString as f, normalizeClass as _, unref as d, renderSlot as b, createVNode as w } from "vue";
import N from "./Input.js";
import U from "./Select.js";
import { _ as q } from "./Field.vue_vue_type_script_setup_true_lang-DRaKs9Lm.js";
import { _ as z } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = {
  key: 0,
  class: "tw-flex tw-h-input tw-items-center tw-text-sm"
}, L = ["id", "aria-labelledby"], P = /* @__PURE__ */ O({
  name: "ll-input-options",
  __name: "InputOptions",
  props: {
    modelValue: { default: () => ({ value: "", option: void 0 }) },
    type: { default: "text" },
    noTruncate: { type: Boolean, default: !1 },
    options: { default: () => [] },
    placeholder: { default: void 0 },
    displayBy: { default: void 0 },
    trackBy: { default: void 0 },
    addBottomSpace: { type: Boolean },
    errorText: {},
    hintText: {},
    id: {},
    errorId: {},
    isReadOnly: { type: Boolean },
    isRequired: { type: Boolean },
    label: {},
    showOptionalInLabel: { type: Boolean },
    fieldset: { type: Boolean },
    isDisabled: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:model-value", "change"],
  setup(B, { emit: g }) {
    const e = B, o = g, V = $(), r = E(), n = T(), a = u(), c = u(!1), t = u();
    function C(l) {
      a.value = String(l), o("update:model-value", {
        value: a.value,
        option: t.value,
        isValueChange: !0,
        type: "input"
      });
    }
    function k() {
      o("change", {
        value: a.value,
        option: t.value,
        isValueChange: !0,
        type: "input"
      });
    }
    function I(l) {
      t.value = l, o("change", {
        value: a.value,
        option: t.value,
        isValueChange: !1,
        type: "select"
      }), o("update:model-value", {
        value: a.value,
        option: t.value,
        isValueChange: !1,
        type: "select"
      });
    }
    if (D(() => {
      t.value || (t.value = e.options[0]);
    }), v(
      () => e.modelValue.value,
      () => {
        a.value = e.modelValue.value;
      },
      { immediate: !0 }
    ), v(
      () => e.modelValue.option,
      () => {
        t.value = e.modelValue.option;
      },
      { immediate: !0 }
    ), r.value)
      throw new Error("ll-input-options: use :model-value or v-model instead of :value.");
    if (r.onInput)
      throw new Error("ll-input-options: use the @update:model-value event instead of @input");
    return (l, s) => (p(), j(q, M(e, {
      class: "stash-input-options",
      "data-test": "stash-input-options"
    }), R({
      default: h(({ fieldId: i, labelId: S }) => {
        var m;
        return [
          e.isReadOnly ? (p(), y("div", A, [
            F("span", {
              id: i,
              "aria-labelledby": S,
              class: "tw-h-min"
            }, f(a.value || 0) + " " + f((m = t.value) == null ? void 0 : m.name), 9, L)
          ])) : (p(), y("div", {
            key: 1,
            class: _(["tw-flex", [d(n)["input-wrapper"], { [d(n)["has-error"]]: !!e.errorText }]])
          }, [
            b(l.$slots, "default", { fieldId: i }, () => [
              w(N, {
                id: i,
                class: "stash-input-options__input",
                "data-test": "stash-input-options|input",
                type: e.type,
                "model-value": a.value,
                disabled: e.isDisabled || e.disabled,
                placeholder: e.placeholder,
                onChange: k,
                "onUpdate:modelValue": C,
                onBlur: s[0] || (s[0] = (x) => c.value = !1),
                onFocus: s[1] || (s[1] = (x) => c.value = !0)
              }, null, 8, ["id", "type", "model-value", "disabled", "placeholder"])
            ]),
            w(U, {
              single: "",
              "hide-search": "",
              "prevent-empty": "",
              class: _(["stash-input-options__select tw-min-w-20", d(n).select]),
              "data-test": "stash-input-options|select",
              "no-truncate": l.noTruncate,
              options: l.options,
              "model-value": t.value,
              "display-by": e.displayBy,
              "track-by": e.trackBy,
              disabled: e.isDisabled || e.disabled,
              "onUpdate:modelValue": I
            }, null, 8, ["class", "no-truncate", "options", "model-value", "display-by", "track-by", "disabled"])
          ], 2))
        ];
      }),
      _: 2
    }, [
      V.hint ? {
        name: "hint",
        fn: h(() => [
          b(l.$slots, "hint")
        ]),
        key: "0"
      } : void 0
    ]), 1040));
  }
}), G = "_select_1jmut_26", H = {
  "input-wrapper": "_input-wrapper_1jmut_2",
  "has-error": "_has-error_1jmut_14",
  select: G
}, J = {
  $style: H
}, Z = /* @__PURE__ */ z(P, [["__cssModules", J]]);
export {
  Z as default
};
//# sourceMappingURL=InputOptions.js.map
